<template>
    <div v-cloak v-if="auth">
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1)"
        ></pagination-component>
        <div class="simple-table structure-table" v-if="Object.keys(imagesList).length">
            <table class="table table-striped table-sm table-hover mb-0">
                <table-headers :headers="tableHeaders"></table-headers>
                <tbody>
                <tr v-for="(image, index) in imagesList">
                    <td :data-title="$lang('Lp.')">
                        {{ pagination.from + parseInt(index) }}
                    </td>
                    <td class="text-break" :data-title="$lang('Nazwa')">
                        <span href="">{{ image.filename }}</span>
                    </td>
                    <td :data-title="$lang('Data przesłania')">
                        <span href="">{{ image.date }}</span>
                    </td>
                    <td :data-title="$lang('Akcje')">
                        <a href="#"
                           class="mx-1"
                           data-toggle="modal"
                           :data-target="'#modalConfirmation-' + index"
                           :title="$lang('Usuń obraz')  + ': ' +  image.filename"
                           :aria-label="$lang('Usuń obraz') + ': ' +  image.filename">
                            {{ $lang('Usuń') }}
                        </a>
                    </td>
                    <div class="modal" :id="'modalConfirmation-' + index" tabindex="-1" role="dialog"
                         :aria-labelledby="'modalConfirmation-' + index + '-label'" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" :id="'modalConfirmation-' + index + '-label'">
                                        {{ $lang('Usunięcie Obrazu') }}
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal"
                                            :aria-label="$lang('Zamknij')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    {{ $lang('Czy na pewno chcesz usunąć obraz "') }}
                                    <strong>{{ image.filename }}</strong>" ?
                                    <img class="w-100 h-auto" :src="'/storage/img/mailing/' + image.filename"/>
                                </div>
                                <div class="modal-footer">
                                    <a href="#" class="btn btn-default" data-dismiss="modal">{{ $lang('Nie') }}</a>
                                    <a href="#" class="btn btn-primary" @click.prevent="confirm(image.filename)"
                                       data-dismiss="modal">{{ $lang('Tak') }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else>
            {{ $lang('Brak wyników') }}
        </div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1)"
        ></pagination-component>
    </div>
</template>
<script>

import axios from 'axios';
import Notification from '../../../mixins/show-notification';
import {EventBus} from "../../../mixins/event-bus";
import TableHeaders from '../../table/table-headers';
import PaginationComponent from '../../pagination-component';

export default {

    name: 'mailing-images-table',

    components: {
        TableHeaders,
        PaginationComponent,
    },

    mixins: [Notification],

    props: {
        auth: {
            type: Boolean,
            required: true
        },
        list_route: {
            type: String,
        },
        images_route: {
            type: String,
        },
        delete_route: {
            type: String,
        },
    },

    data() {
        return {
            imagesList: [],
            pagination: [],
            perPage: 20,
            sortColumn: 'filename',
            sortOrder: 'asc',
            tableHeaders: [
                {title: this.$lang('Lp.')},
                {title: this.$lang('Nazwa'), column: 'filename', sort: 'alpha'},
                {title: this.$lang('Data przesłania'), column: 'date', sort: 'numeric'},
                {title: this.$lang('Akcje')}
            ],
        };
    },
    created() {
        this.setEventBusListeners();
        this.requestImages();
    },

    watch: {
        libraryID() {
            this.requestImages();
        },
        sortColumn() {
            this.requestImages();
        }
    },

    methods: {
        confirm(filename) {
            this.deleteImage(filename);
        },

        requestImages(filters) {
            const params = {
                ...filters,
                perPage: this.perPage,
                sortColumn: this.sortColumn,
                sortOrder: this.sortOrder
            };
            return axios.get(this.list_route, {params}).then((response) => {
                this.imagesList = response.data.images.data;
                this.pagination = response.data.images;
            }).catch((error) => {
                const message = (error.response.data ? error.response.data : error.response.statusText);
                this.showNotification('error', message);
            });
        },

        onChangePage({ value }) {
            this.requestImages({ page: value });
        },
        onSortByColumn({ column, order }) {
            this.sortColumn = column;
            this.sortOrder = order;

            this.requestImages({ page: this.pagination.current_page });
        },
        setEventBusListeners() {
            EventBus.$on('changePage', this.onChangePage)
                .$on('sortByColumn', this.onSortByColumn);
        },

        deleteImage(filename) {
            const params = {
                filename: filename,
            }
            return axios.post(this.delete_route, params)
                .then((response) => {
                    this.requestImages({page: this.pagination.current_page});
                    this.showNotification('success', "Usunięto obraz");
                }).catch((error) => {
                    const message = (error.response.data ? error.response.data : error.response.statusText);
                    this.showNotification('error', message);
                });
        },
    }

}

</script>
